export class BasketUserModel {
    public name: string;
    public uid: string;
}